import PageContainer from '@Guidelines/Layout/PageContainer';
import PageHeader from '@Guidelines/Layout/PageHeader';
import AiEnginesContent from '@UI/Pages/Administration/AiEngines/AiEnginesContent';
import AiEnginesNotifications from '@UI/Pages/Administration/AiEngines/AiEnginesNotifications';
import AiEnginesConfirmationDialogs from '@UI/Pages/Administration/AiEngines/ConfirmationDialogs/AiEnginesConfirmationDialogs';
import ModelSidebar from '@UI/Pages/Administration/AiEngines/Sidebars/ModelSidebar';
import ProviderSidebar from '@UI/Pages/Administration/AiEngines/Sidebars/ProviderSidebar';
import type * as React from 'react';

/**
 * Assembles the page: header, the data-owning `AiEnginesContent` (providers and models tabs),
 * `ProviderSidebar`, `ModelSidebar`, `AiEnginesConfirmationDialogs` and notifications —
 * unconditional siblings of the content rather than repeated across its six loading/error/empty/
 * nominal states.
 */
const AiEnginesPage: React.FC = () => {
	return (
		<PageContainer>
			<PageHeader
				eyebrow="CONFIGURATION"
				title="Moteurs d'IA"
				description="Déclarez vos fournisseurs d'IA, composez votre catalogue de modèles, puis affectez un modèle à chaque usage."
			/>
			<AiEnginesContent />
			<ProviderSidebar />
			<ModelSidebar />
			<AiEnginesConfirmationDialogs />
			<AiEnginesNotifications />
		</PageContainer>
	);
};

export default AiEnginesPage;
